let config = {
    client_id: '23S2ZN',
    client_secret: '3b3980c59696e014ceae84b4f73fd0d5'
}
export default config